export const GET_POINTS_DETAIL = "admin/GET_POINTS_DETAIL";
export const GET_POINTS_DETAIL_SUCCESS = "admin/GET_POINTS_DETAIL_SUCCESS";
export const GET_POINTS_DETAIL_FAILURE = "admin/GET_POINTS_DETAIL_FAILURE";
